import { render } from "./CookiesDialog.vue?vue&type=template&id=6f4332af"
import script from "./CookiesDialog.vue?vue&type=script&lang=js"
export * from "./CookiesDialog.vue?vue&type=script&lang=js"

import "./CookiesDialog.vue?vue&type=style&index=0&id=6f4332af&lang=css"

import exportComponent from "C:\\Users\\khale\\OneDrive\\Cookies BIS\\CookiesBIS\\core\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__